var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAdminIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.71149 21.6789C4.75414 21.774 10.7919 21.774 13.8346 21.6789C14.8329 21.6314 15.546 20.7757 15.451 19.8248L14.9756 15.2133C14.6903 12.9313 13.0264 11.1723 10.887 10.6493L8.74762 15.974L8.27221 12.1231H8.55746C8.74762 12.1231 8.89025 11.9805 8.89025 11.7903V10.7444C8.89025 10.5542 8.74762 10.4116 8.55746 10.4116H6.89351C6.70334 10.4116 6.56072 10.5542 6.56072 10.7444V11.7903C6.56072 11.9805 6.70334 12.1231 6.89351 12.1231H7.17876L6.70334 15.974L4.56398 10.6493C2.42461 11.1723 0.760663 12.9313 0.475414 15.2133L0 19.8248C0 20.7757 0.760664 21.6314 1.71149 21.6789Z",
    fill: "#990000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.79711 9.50829C10.4228 9.50829 12.5513 7.37978 12.5513 4.75414C12.5513 2.1285 10.4228 0 7.79711 0C5.17147 0 3.04297 2.1285 3.04297 4.75414C3.04297 7.37978 5.17147 9.50829 7.79711 9.50829Z",
    fill: "#990000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminIcon);
export default __webpack_public_path__ + "static/media/adminIcon.846962d76a75ae21525d949fcb663382.svg";
export { ForwardRef as ReactComponent };